export { default } from "~/pages/resource/[slug]";

import { paths, getDetailProps } from "~/modules/static-paths";

export async function getStaticPaths() {
    return { paths: await paths.blog(), fallback: false };
}

export async function getStaticProps({ params }) {
    return getDetailProps({ type: "posts", slug: params.slug });
}
